module.exports = __webpack_public_path__ + "img/storie01.29a40b09.svg";